/**
 * Geometria do velocímetro — arco de 240°, com o teto da escala em 1,2× a meta
 * (estourar a meta precisa caber no desenho).
 *
 * Vive separada do componente de propósito: aqui não há JSX, então o `node
 * --test` consegue importar e exercitar o cálculo direto. O `.tsx` só desenha.
 */

export const TETO = 1.2        // fim da escala: 120 % da meta
export const INICIO = -120     // graus
export const FIM = 120
export const RAIO = 42
export const CX = 50
export const CY = 50
export const TRACO = 7

/**
 * Folga entre faixas vizinhas, para não se fundirem num borrão. Tem de ser
 * PEQUENA: a faixa amarela cobre só 10 pontos de uma escala de 120 — ou seja,
 * 20° de um arco de 240° — e uma folga generosa a consumiria.
 */
export const FOLGA = 0.005

/** Proporção → graus, saturando no teto da escala. */
export function angulo(proporcao: number): number {
  const p = Number.isFinite(proporcao) ? Math.max(proporcao, 0) : 0
  return INICIO + (FIM - INICIO) * Math.min(p / TETO, 1)
}

export function ponto(graus: number, raio: number): [number, number] {
  const rad = ((graus - 90) * Math.PI) / 180
  return [CX + raio * Math.cos(rad), CY + raio * Math.sin(rad)]
}

/** O `d` de um `<path>` que vai de p1 a p2 no arco. */
export function arco(p1: number, p2: number, raio: number): string {
  const [x1, y1] = ponto(angulo(p1), raio)
  const [x2, y2] = ponto(angulo(p2), raio)
  const grande = angulo(p2) - angulo(p1) > 180 ? 1 : 0
  return `M${x1} ${y1} A${raio} ${raio} 0 ${grande} 1 ${x2} ${y2}`
}

/** A ponta da agulha. É o único par de coordenadas que muda quando o valor muda. */
export function pontaDaAgulha(proporcao: number): [number, number] {
  return ponto(angulo(proporcao), RAIO - 11)
}
